import React from 'react';
import { connect } from 'react-redux';

import CharityComponent from '../../components/app/Charity/Charity';

import * as actions from '../../actions/charity/charity';

const Charity = (props) => {
  return (
    <CharityComponent {...props} />
  );
};

export default connect(({ charity, user }) => ({ charityMain: charity.charity, user }), actions)(Charity);
